import { render, staticRenderFns } from "./FootBar.vue?vue&type=template&id=92c5ab58"
import script from "./FootBar.vue?vue&type=script&lang=js"
export * from "./FootBar.vue?vue&type=script&lang=js"
import style0 from "./FootBar.vue?vue&type=style&index=0&id=92c5ab58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports